(function () {
  const root = document.getElementById('limited-sample-data');


  if (!root) return;


  const status = document.getElementById('limited-sample-status');


  const loggedIn =
    root.dataset.customerLoggedIn === 'true';


  let eligibility = {};


  const eligibilityScript =
    document.getElementById('limited-sample-eligibility');


  if (eligibilityScript) {
    try {
      eligibility =
        JSON.parse(eligibilityScript.textContent || '{}') || {};
    } catch (e) {
      console.error(
        'Could not parse sample eligibility data.',
        e
      );
      eligibility = {};
    }
  }


  const variantAvailability = {};
  const variantsScript = document.getElementById('limited-sample-variants');
  if (variantsScript) {
    try {
      const variants = JSON.parse(variantsScript.textContent || '[]');
      variants.forEach(function (variant) {
        variantAvailability[String(variant.id)] = variant.available === true;
      });
    } catch (error) {
      console.error('Could not parse sample variant availability.', error);
    }
  }

  let displayRequest = 0;

  function findProductForm() {
    return document.querySelector(
      'form[data-type="add-to-cart-form"]'
    );
  }


  function findVariantInput() {
    const form = findProductForm();


    if (!form) return null;


    return form.querySelector(
      '.product-variant-id'
    );
  }


  function findAddButton() {
    const form = findProductForm();


    if (!form) return null;


    return form.querySelector(
      '[name="add"]'
    );
  }


  function getSelectedVariantId() {
    const variantInput =
      findVariantInput();


    if (!variantInput) return null;


    return String(variantInput.value);
  }


  function todayDateOnly() {
    const now = new Date();


    const year =
      now.getFullYear();


    const month =
      String(now.getMonth() + 1)
        .padStart(2, '0');


    const day =
      String(now.getDate())
        .padStart(2, '0');


    return `${year}-${month}-${day}`;
  }


  function formatDate(dateString) {
    if (!dateString) return '';


    const parts =
      dateString.split('-');


    if (parts.length !== 3) {
      return dateString;
    }


    const date = new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );


    return date.toLocaleDateString(
      undefined,
      {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
    );
  }


  function setButtonState({
    disabled,
    text
  }) {
    if (variantAvailability[getSelectedVariantId()] === false) {
      disabled = true;
      text = 'OUT OF STOCK';
    }

    const button =
      findAddButton();


    if (!button) return;


    const textSpan =
      button.querySelector('span');


    if (!button.dataset.originalText) {
      button.dataset.originalText =
        textSpan
          ? textSpan.textContent.trim()
          : button.textContent.trim();
    }


    button.disabled =
      disabled;


    button.setAttribute(
      'aria-disabled',
      disabled ? 'true' : 'false'
    );


    const newText =
      text ||
      button.dataset.originalText ||
      'Add to cart';


    if (textSpan) {
      textSpan.textContent =
        newText;
    } else {
      button.textContent =
        newText;
    }


    button.classList.toggle(
      'limited-sample-disabled',
      disabled
    );
  }


  async function updateEligibilityDisplay() {
    const request = ++displayRequest;
    const variantId =
      getSelectedVariantId();


    if (!variantId) return;


    if (!loggedIn) {
      if (status) {
        status.innerHTML =
          '<strong>Please log in to order this sample.</strong>';
      }


      setButtonState({
        disabled: true,
        text: 'LOG IN TO ORDER'
      });


      return;
    }


    const eligibleAfter =
      eligibility[variantId];


    if (
      eligibleAfter &&
      eligibleAfter > todayDateOnly()
    ) {
      if (status) {
        status.innerHTML =
          '<span class="sample-ineligible">' +
          'Previously ordered.<br>' +
          'Eligible again ' +
          formatDate(eligibleAfter) +
          '.</span>';
      }


      setButtonState({
        disabled: true,
        text: 'NOT ELIGIBLE'
      });


      return;
    }


    if (variantAvailability[variantId] !== true) {
      if (status) status.textContent = '';
      setButtonState({
        disabled: true,
        text: variantAvailability[variantId] === false
          ? (window.variantStrings?.soldOut || 'SOLD OUT')
          : (window.variantStrings?.unavailable || 'UNAVAILABLE')
      });
      return;
    }

    try {
      const cart = await getCart();
      if (request !== displayRequest || variantId !== getSelectedVariantId()) return;


      const existingQty =
        getVariantQuantity(
          cart,
          variantId
        );


      if (existingQty >= 1) {
        if (status) {
          status.innerHTML =
            '<span class="sample-ineligible">' +
            'This sample is already in your cart.' +
            '</span>';
        }


        setButtonState({
          disabled: true,
          text: 'ALREADY IN CART'
        });


        return;
      }


    } catch (error) {
      console.error(
        'Could not check sample cart status:',
        error
      );
    }


    if (request !== displayRequest || variantId !== getSelectedVariantId()) return;

    if (!eligibleAfter) {
      if (status) {
        status.innerHTML =
          '<span class="sample-eligible">✓ Eligible to order</span>';
      }


      setButtonState({
        disabled: false,
        text: window.variantStrings?.addToCart || 'ADD TO CART'
      });


      return;
    }


    if (
      eligibleAfter <= todayDateOnly()
    ) {
      if (status) {
        status.innerHTML =
          '<span class="sample-eligible">✓ Eligible to order</span>';
      }


      setButtonState({
        disabled: false,
        text: window.variantStrings?.addToCart || 'ADD TO CART'
      });


      return;
    }
  }


  updateEligibilityDisplay();


  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.closest(
            'product-info'
        )
        ) {
        setTimeout(
          updateEligibilityDisplay,
          100
        );
      }
    }
  );


  document.addEventListener(
    'variant:change',
    function () {
      setTimeout(
        updateEligibilityDisplay,
        100
      );
    }
  );


  const variantInput =
    findVariantInput();


  if (variantInput) {
    const observer =
      new MutationObserver(function () {
        updateEligibilityDisplay();
      });


    observer.observe(
      variantInput,
      {
        attributes: true,
        attributeFilter: ['value']
      }
    );
  }
  async function getCart() {
  const response = await fetch(
    window.Shopify.routes.root + 'cart.js',
    {
      headers: {
        Accept: 'application/json'
      }
    }
  );


  if (!response.ok) {
    throw new Error('Unable to retrieve cart.');
  }


  return response.json();
}


function getVariantQuantity(cart, variantId) {
  return cart.items.reduce(function (total, item) {
    if (String(item.variant_id) === String(variantId)) {
      return total + Number(item.quantity || 0);
    }


    return total;
  }, 0);
}


function showSampleMessage(message) {
  if (!status) return;


  status.innerHTML =
    '<span class="sample-ineligible">' +
    message +
    '</span>';
}


const addButton = findAddButton();
const productForm = findProductForm();


if (addButton && productForm) {
  addButton.addEventListener(
    'click',
    async function (event) {


      // STOP Shopify/theme immediately.
      // We will allow the submission ourselves if everything checks out.
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      const variantId = getSelectedVariantId();


      if (!variantId) return;
      if (!loggedIn || variantAvailability[variantId] !== true) {
        updateEligibilityDisplay();
        return;
      }


      const eligibleAfter =
        eligibility[variantId];


      // 2-year restriction
      if (
        eligibleAfter &&
        eligibleAfter > todayDateOnly()
      ) {
        showSampleMessage(
          'This sample is not eligible for reorder until ' +
          formatDate(eligibleAfter) +
          '.'
        );


        setButtonState({
          disabled: true,
          text: 'NOT ELIGIBLE'
        });


        return;
      }


      try {
        const cart = await getCart();


        const existingQty =
          getVariantQuantity(
            cart,
            variantId
          );


        if (variantId !== getSelectedVariantId()) return;

        // Already in cart
        if (existingQty >= 1) {
          showSampleMessage(
            'Only one of each sample may be ordered. This sample is already in your cart.'
          );


          return;
        }


        // Everything is valid.
        // Now allow the theme's normal product form to submit.
        productForm.requestSubmit(addButton);


        setTimeout(function () {
          updateEligibilityDisplay();
        }, 1000);


      } catch (error) {
        console.error(
          'Limited sample cart check failed:',
          error
        );
      }
    },
    true
  );
}
})();